<template>
    <span class="fi" :class="`fi-${cleanIsoCode}`" />
</template>

<script lang="ts" setup>

import { computed } from 'vue';

const props = defineProps<{ isoCode: string }>();

const alternativeFlagIdentifiers: Record<string, string> = {
    ni: 'gb-nir',
    germany: 'de',
    france: 'fr',
};

const cleanIsoCode = computed<string>(() => {
    const alternativeCode: string | null = alternativeFlagIdentifiers[props.isoCode.toLowerCase()];
    if (alternativeCode) return alternativeCode;
    return props.isoCode.toLowerCase();
});

</script>

<style lang="scss" scoped>

.fi {
    line-height: normal;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-position: 50%;
    background-repeat: no-repeat;
}

</style>
